import { lazy } from 'react';
import type { RouteObject } from 'react-router';

import { MainLayout } from '@/layout';
import SearchParamsGuard from '@/router/SearchParamsGuard';

const routes: RouteObject[] = [
  {
    path: 'project',
    Component: MainLayout,
    children: [
      {
        path: '',
        Component: () => (
          <SearchParamsGuard
            configs={[
              {
                prefix: 'project',
              },
            ]}
          />
        ),
        children: [
          {
            path: '',
            Component: lazy(() => import('@/page/project/ProjectListPage')),
          },
          {
            path: ':projectId',
            Component: lazy(() => import('@/page/task/TaskListPage')),
          },
        ],
      },
      {
        path: 'create',
        Component: lazy(() => import('@/page/project/ProjectCreaetPage')),
      },
    ],
  },
];

export default routes;
